
export const getRoundSpecialsRounds = (state) => state.roundSpecials.rounds;
export const getRoundSpecialsLastRoundId = (state) => state.roundSpecials.lastRoundId;
export const getRoundSpecialsLastDate = (state) => state.roundSpecials.lastDate;
export const getRoundSpecialDetails = (state) => state.roundSpecials.roundDetails;
export const getRoundSpecialsTimeline = (state) => state.roundSpecials.roundTimeline;
export const getRoundSpecialOddsDetails = (state) => state.roundSpecials.oddsDetails;
export const getRoundSpecialDisplayedMarketOdds = (state) => state.roundSpecials.marketsDisplayed;
export const getRoundSpecialOddsHistoryTemplate = (state) => state.roundSpecials.roundSpecialOddsHistoryTemplate;
export const getRoundSpecialSelectedMarketHistoryOdds = (state) => state.roundSpecials.selectedMarketOddsHistory;
